import { render, staticRenderFns } from "./CreditsModal.vue?vue&type=template&id=2d8dcf44&scoped=true&"
import script from "./CreditsModal.vue?vue&type=script&lang=js&"
export * from "./CreditsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreditsModal.vue?vue&type=style&index=0&id=2d8dcf44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8dcf44",
  null
  
)

export default component.exports